import { useFeatureFlag, useFeatureFlagsReady } from '../../contexts/featureFlagContext';
/**
 * Growth redesign thread flag (GRW-01, `features/flags.yaml`). Gates the
 * pursuit THREAD on Home, Growth Home "Changed since" and the landscape seat
 * history. Off = those surfaces keep today's content. Requires
 * `growth_record_shell_v1` (FND-17) wherever it is on.
 */ export const GROWTH_THREAD_FLAG = 'growth_thread_v1';
/** True only once flags are loaded and the flag is on (never flashes the thread). */ export function useGrowthThreadEnabled() {
    const ready = useFeatureFlagsReady();
    const on = useFeatureFlag(GROWTH_THREAD_FLAG);
    return ready && on === true;
}
/**
 * GRW-35 pursuit graph flag (`features/flags.yaml`). On: the pursuit's
 * Knowledge graph reads GetPursuitGraph (pursuit-filtered projection) and
 * "Add to this pursuit" writes link rows. Off = today's whole-tenant panel.
 */ export const GROWTH_PURSUIT_GRAPH_FLAG = 'growth_pursuit_graph_v1';
/** True only once flags are loaded and the flag is on. */ export function useGrowthPursuitGraphEnabled() {
    const ready = useFeatureFlagsReady();
    const on = useFeatureFlag(GROWTH_PURSUIT_GRAPH_FLAG);
    return ready && on === true;
}
